import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { InventoryProductViewModel } from '@inventory/models/inventory-view.model';
import { PlatformEnum } from '@panamax/app-state';

@Component({
  selector: 'app-inventory-information-modal',
  templateUrl: './inventory-information-modal.component.html',
  styleUrls: ['./inventory-information-modal.component.scss'],
})
export class InventoryInformationModalComponent {
  readonly platformEnum = PlatformEnum;

  @Input() inventoryItem: InventoryProductViewModel;
  @Input() platformType: PlatformEnum;
  @Output()
  dismissModalEmitter: EventEmitter<boolean> = new EventEmitter();
  constructor() {}

  dismissModal() {
    this.dismissModalEmitter.emit(true);
  }
}
